import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { SassPlay } from "../../../app-constants";
import Video1 from "../../images/services-usa/saas-video/case_video/swell_chat.mp4";
import Video2 from "../../images/services-usa/saas-video/case_video/star_stake.mp4";
import Video3 from "../../images/services-usa/saas-video/case_video/kaizo.mp4";
import Video4 from "../../images/services-usa/saas-video/case_video/valicom.mp4";

function Explainervideo() {
  const [isActive, setIsActive] = useState(false);

  // Step 2: Toggle function
  const toggleActive = () => {
    setIsActive(!isActive);
  };

  return (
    <section className="explainer_video p-100" id="case_btn">
      <Container>
        <Row>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={7}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              SaaS Explainer Videos <span>Case Studies</span>
            </h2>
            <p>
              Our SaaS creatives love to take on challenges, and the case
              studies made on our software explainer videos speak about our
              creative zeal.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="explainer_case_main">
              <div className={`explainer_item ${isActive ? "active" : ""}`}>
                <div className="explainer_case_img">
                  <div className="img_box">
                    <StaticImage
                      src="../../images/services-usa/saas-video/case-study/swell-chat.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={960}
                      height={540}
                    />
                    <div className="explainer_play_btn" onClick={toggleActive}>
                      {SassPlay}
                    </div>
                  </div>
                  <div className="case_video">
                    <video muted loop autoPlay id="myVideo" playsInline>
                      <source src={Video1} type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div className="explainer_case_content">
                  <span>Case Study</span>
                  <h2>SwellChat</h2>
                  <div className="case_btn_main">
                    <div className="case_btn_item">
                      <p>B2B</p>
                    </div>
                    <div
                      className="case_btn_item"
                      style={{ background: "#D1E7FD" }}
                    >
                      <p>Motion Graphics</p>
                    </div>
                  </div>
                  <p>
                    The challenge was to connect with benefits professionals and
                    convince them to sign up to a dedicated B2B SaaS platform
                    for benefits correspondence: SwellSpace. The video did great
                    to get the word out, and gain traction.
                  </p>
                  <div className="satisfaction_item">
                    <p>
                      <strong>98%</strong> User Satisfaction Rate
                    </p>
                  </div>
                  <div className="satisfaction_item">
                    <p>
                      <strong>50%</strong> Increase in User Engagement
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="explainer_case_main">
              <div className={`explainer_item ${isActive ? "active" : ""}`}>
                <div className="explainer_case_img order-lg-2 order-sm-1">
                  <div className="img_box">
                    <StaticImage
                      src="../../images/services-usa/saas-video/case-study/starstake.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={960}
                      height={540}
                    />
                    <div className="explainer_play_btn" onClick={toggleActive}>
                      {SassPlay}
                    </div>
                  </div>
                  <div className="case_video">
                    <video muted loop autoPlay id="myVideo" playsInline>
                      <source src={Video2} type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div className="explainer_case_content">
                  <span>Case Study</span>
                  <h2>StarStake</h2>
                  <div className="case_btn_main">
                    <div className="case_btn_item">
                      <p>NFT</p>
                    </div>
                    <div
                      className="case_btn_item"
                      style={{ background: "#FDDDE1" }}
                    >
                      <p>Motion Graphics</p>
                    </div>
                  </div>
                  <p>
                    The goal was to create an outstanding SaaS promo for the
                    world’s first access NFT marketplace, StarStake. The video
                    did well to draw both creators and fans to the platform.
                  </p>
                  <div className="satisfaction_item">
                    <p>
                      <strong>89%</strong> User Satisfaction Rate
                    </p>
                  </div>
                  <div className="satisfaction_item">
                    <p>
                      <strong>33%</strong> Increase in User Engagement
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="explainer_case_main">
              <div className={`explainer_item ${isActive ? "active" : ""}`}>
                <div className="explainer_case_img">
                  <div className="img_box">
                    <StaticImage
                      src="../../images/services-usa/saas-video/case-study/kaizo.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={960}
                      height={540}
                    />
                    <div className="explainer_play_btn" onClick={toggleActive}>
                      {SassPlay}
                    </div>
                  </div>
                  <div className="case_video">
                    <video muted loop autoPlay id="myVideo" playsInline>
                      <source src={Video3} type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div className="explainer_case_content">
                  <span>Case Study</span>
                  <h2>Kaizo Analytics</h2>
                  <div className="case_btn_main">
                    <div className="case_btn_item">
                      <p>B2B</p>
                    </div>
                    <div
                      className="case_btn_item"
                      style={{ background: "#D1E7FD" }}
                    >
                      <p>Motion Graphics</p>
                    </div>
                  </div>
                  <p>
                    We had the goal to raise awareness for a B2B team management
                    tool with a video. The campaign was brought to life with
                    ninja-style characters. The video did an astoundingly good
                    job!
                  </p>
                  <div className="satisfaction_item">
                    <p>
                      <strong>87%</strong> User Satisfaction Rate
                    </p>
                  </div>
                  <div className="satisfaction_item">
                    <p>
                      <strong>16%</strong> Increase in User Engagement
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="explainer_case_main">
              <div className={`explainer_item ${isActive ? "active" : ""}`}>
                <div className="explainer_case_img order-lg-2 order-sm-1">
                  <div className="img_box">
                    <StaticImage
                      src="../../images/services-usa/saas-video/case-study/valicom.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={960}
                      height={540}
                    />
                    <div className="explainer_play_btn" onClick={toggleActive}>
                      {SassPlay}
                    </div>
                  </div>
                  <div className="case_video">
                    <video muted loop autoPlay id="myVideo" playsInline>
                      <source src={Video4} type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div className="explainer_case_content">
                  <span>Case Study</span>
                  <h2>Valicom</h2>
                  <div className="case_btn_main">
                    <div className="case_btn_item">
                      <p>NFT</p>
                    </div>
                    <div
                      className="case_btn_item"
                      style={{ background: "#FDDDE1" }}
                    >
                      <p>Motion Graphics</p>
                    </div>
                  </div>
                  <p>
                    The objective was to deliver value of a SaaS tool for
                    technology expense management with a video. With simple
                    copy, and phenomenal motion art, the video did well to sell
                    it quick and smart.
                  </p>
                  <div className="satisfaction_item">
                    <p>
                      <strong>91%</strong> User Satisfaction Rate
                    </p>
                  </div>
                  <div className="satisfaction_item">
                    <p>
                      <strong>44%</strong> Increase in User Engagement
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Explainervideo;
